module.exports = new __parcel__URL__("92782_sq.ca668123.jpg").toString();